import { TASK_FIELDS } from '../../../../utils/formFields/task';
import {
  // convertArrayStrToObject,
  optionalFormField,
} from '../../../../utils/methods/helpers';
import { patrolFormFields } from '../../../../utils/patrol';

export const generalSection = ({
  users,
  sites = [],
  hideAssignee,
  location,
  siteEnabled,
}) => {
  return [
    TASK_FIELDS.name,
    ...(!hideAssignee
      ? [
          TASK_FIELDS.assignee({
            options: Object.entries(users).map(([key, value]) => ({
              id: key,
              name: value,
            })),
          }),
        ]
      : []),
    ...optionalFormField({
      showWhen: siteEnabled,
      field: patrolFormFields.site({
        options: sites.map(site => ({
          ...site,
          id: site.id,
          name: `(${site.siteId}) ${site.businessClientName} - ${site.siteName}`,
        })),
        required: false,
        disabled: false,
        info: 'Please set Client/Site',
        valueType: 'object', // whole site object will be selected, if not passed only id will be selected in formik
        // this is useful eg. when you have to get centerofgravity related to that site
        showPopup: true, // this field can show popup
        useSelectedValue: true,
        surfaceTouched: location.length > 0,
        handleSelectChange: ({ e, handleChange, value, name }) => {
          // this will let site field change and form field with required value
          e.target.value = value;
          e.target.name = name;
          handleChange(e);
        },
      }),
    }),
  ];
};
